export default {
    baseStyle: {
        // Title
        title: {
            textStyle: 'webH2',
            mt: {base: 12, lg: 0},
            mb: {base: 12, lg: 16}
        },

        // Loading skeleton
        skeletonRow: {
            align: 'center',
            justify: 'space-between',
            w: 'full',
            gap: 3
        },
        skeletonRadioCircle: {
            minWidth: '16px',
            height: '16px',
            border: '1px solid',
            borderColor: 'gray.300',
            borderRadius: 'full',
            margin: '4px',
            flexShrink: 0
        },
        skeletonIcon: {
            height: '24px',
            width: '24px',
            flexShrink: 0
        },
        skeletonContent: {
            flex: '0 0 202px',
            gap: 2
        },
        skeletonTextLong: {
            height: '14px',
            width: '120px'
        },
        skeletonTextMedium: {
            height: '14px',
            width: '180px'
        },
        skeletonTextShort: {
            height: '14px',
            width: '40px',
            ml: 'auto',
            flexShrink: 0
        },
        skeletonFullWidth: {
            height: '60px'
        },

        // Form layout
        methodsStack: {
            spacing: 6
        },
        optionsStack: {
            spacing: 6
        },

        // Radio control margin
        radio: {
            sx: {
                '& .chakra-radio__control': {
                    margin: '4px'
                }
            }
        },

        // Shipping method option
        optionWrapper: {
            flex: '0 0 202px'
        },
        optionRow: {
            justify: 'space-between',
            w: 'full',
            align: 'flex-start'
        },
        optionIcon: {
            w: '24px',
            h: '24px',
            mr: 3,
            flexShrink: 0
        },
        optionIconImage: {
            w: '24px',
            h: '24px',
            mr: 3,
            flexShrink: 0,
            objectFit: 'contain'
        },
        optionName: {
            textStyle: 'webH4',
            marginBottom: {base: 1}
        },
        optionDescription: {
            textStyle: 'bodyXsSRegular'
        },
        optionPrice: {
            textStyle: 'bodyXsRegular',
            flex: 1,
            textAlign: 'right',
            textTransform: 'uppercase'
        },

        // BOPIS option
        bopisAvailability: {
            textStyle: 'bodyXsRegular',
            mb: 1
        },
        bopisStoreName: {
            textStyle: 'bodyXsRegular',
            mb: 2,
            textTransform: 'capitalize'
        },
        bopisChangeStoreButton: {
            textStyle: 'bodyXsLink',
            h: 'auto',
            minH: 'auto'
        }
    }
}
